import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import { store } from '@/store'
import VueMatomo from 'vue-matomo'

import '@/assets/tailwind.scss'

const app = createApp(App)
app.use(store)
app.use(router)

if (process.env.VUE_APP_MATOMO_ACTIVE === 'ON') {
  app.use(VueMatomo, {
    host: process.env.VUE_APP_MATOMO_HOST,
    siteId: process.env.VUE_APP_MATOMO_SITE_ID,
    enableHeartBeatTimer: process.env.VUE_APP_MATOMO_HEARTBEART === 'ON',
    router: router
  })
  window._paq.push(['alwaysUseSendBeacon'])
}

app.mount('#app')
